import context from '../context'
import getComponentKey from '@/utils/getComponentKey'
import { actionCreators as dialogActionCreators } from './Dialogs'
import { dialogTypes } from '@/dialogs'
import { allowErrorDialog } from '@/utils/fetch'

export const initialState = {
  fetching: false,
  changing: false,
  error: null,
  passwordValidity: null,
  componentKey: getComponentKey()
}

export const actionTypes = {
  fetching: 'password/fetching',
  fetched: 'password/fetched',
  changing: 'password/changing',
  changed: 'password/changed',
  error: 'password/error',
  clearError: 'password/clearError'
}

export const actionCreators = {

  getPasswordValidity: () => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.userProfile.getPasswordValidity(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  clearError: () => ({
    type: actionTypes.clearError
  }),
  changePassword: (currentPassword, newPassword) => (dispatch) => {
    dispatch({ type: actionTypes.changing })
    context.api.userProfile.changePassword({ currentPassword, newPassword }, allowErrorDialog)
      .then(result => {
        let error = null
        if (result.success === true) {
          dispatch(dialogActionCreators.openDialog({
            dialogType: dialogTypes.alert,
            title: 'Security.ChangePassword',
            localizedContent: result.message
          }))
          dispatch(actionCreators.getPasswordValidity())
        } else {
          error = {
            localizedMessage: result.message,
            validationErrors: result.validationErrors.map(msg => ({
              members: ['newPassword', 'repeatNewPassword'],
              localizedMessage: msg
            }))
          }
        }
        dispatch({ type: actionTypes.changed, data: error })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { changing: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, componentKey: getComponentKey(), passwordValidity: action.data }
    case actionTypes.changing: return { ...state, changing: true, error: null }
    case actionTypes.changed: return { ...state, changing: false, componentKey: getComponentKey(), error: action.data }
    case actionTypes.error: return { ...state, ...action.update }
    case actionTypes.clearError: return { ...state, error: null, componentKey: getComponentKey() }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/Password.js